import { render } from "./SidebarLandingPageLinks.vue?vue&type=template&id=42d8735f&scoped=true"
import script from "./SidebarLandingPageLinks.vue?vue&type=script&lang=js"
export * from "./SidebarLandingPageLinks.vue?vue&type=script&lang=js"

import "./SidebarLandingPageLinks.vue?vue&type=style&index=0&id=42d8735f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d8735f"]])

export default __exports__